export class EmpresaEnvioCreditoVO {

  idRda: number;
  cnpj: string;
  idPeriodoGeracao: number

}
